import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  toggle() {
    this.itemTargets.forEach((item) => {
      item.classList.toggle("hidden");
    });

    // Toggle menu button icons
    const button = this.element.querySelector('button[aria-controls="mobile-menu"]');
    if (button) {
      const openIcon = button.querySelector("svg:first-of-type");
      const closeIcon = button.querySelector("svg:last-of-type");

      if (openIcon && closeIcon) {
        openIcon.classList.toggle("hidden");
        openIcon.classList.toggle("block");
        closeIcon.classList.toggle("hidden");
        closeIcon.classList.toggle("block");
      }
    }
  }
}
